module.exports = (__parcel__import__("e7G0m")).then(() => parcelRequire('emu4l'));